import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SketchPicker } from 'react-color';
import { Button, Table } from 'antd';
import chartColors from 'utils/chartcolors';
import AxisRangeSelector from './AxisRangeSelector';
import StrokeWidthSelector from './StrokeWidthSelector';

const TagListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-color: white;
  margin-bottom: 5px;
  position: relative;
  background-color: ${props => (props.selected ? '#4592b2' : 'white')};
  color: ${props => (props.selected ? 'white' : 'black')};
  opacity: ${props => (props.isHidden ? 0.5 : 1)};
  cursor: pointer;
  max-width: 90%;
`;

const ColorWrapper = styled.div`
  position: absolute;
  width: 10px;
  height: 100%;
  display: flex;
  flex: 1;
  background-color: ${props => props.color};
`;

const TagListContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  padding: 8px;
  .value {
    font-size: 0.8rem;
  }

  .label {
    font-size: 1rem;
  }
`;

const TagListItem = ({ value, label, color, selected, onClick, hidden }) => (
  <TagListWrapper onClick={onClick} selected={selected} isHidden={hidden}>
    <ColorWrapper color={color} />
    <TagListContentWrapper>
      <div className="label">{label}</div>
      <div className="value">{value}</div>
    </TagListContentWrapper>
  </TagListWrapper>
);

TagListItem.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
};

TagListItem.defaultProps = {
  hidden: false,
};

const SidebarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ListWrapper = styled.div`
  width: 50%;
`;

const SettingsWrapper = styled.div`
  width: 40%;
`;

class EditTagSidebar extends React.Component {
  static defaultProps = {
    hiddenSeries: {},
    axisConfig: {},
    strokeWidths: {},
    onChangeAxisConfig: null,
    onChangeStrokeWidth: (tagId, value) => {},
  };

  static propTypes = {
    hiddenSeries: PropTypes.objectOf(PropTypes.bool),
    tags: PropTypes.array.isRequired,
    colors: PropTypes.objectOf(PropTypes.string).isRequired,
    removeTag: PropTypes.func.isRequired,
    handleColorChange: PropTypes.func.isRequired,
    axisConfig: PropTypes.object,
    strokeWidths: PropTypes.objectOf(PropTypes.number),
    onChangeAxisConfig: PropTypes.func,
    onChangeStrokeWidth: PropTypes.func,
    toggleHide: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    if (props.tags.length > 0) {
      this.state.selectedTag = props.tags[0].value;
    }
  }

  state = {
    selectedTag: null,
  };

  onChangeAxisConfig = values => {
    this.props.onChangeAxisConfig(this.state.selectedTag, values);
  };

  onChangeStrokeWidth = value => {
    this.props.onChangeStrokeWidth(this.state.selectedTag, value.width);
  };

  render() {
    const {
      tags,
      colors,
      handleColorChange,
      removeTag,
      hiddenSeries,
      onChangeAxisConfig,
      onChangeStrokeWidth,
    } = this.props;
    const dataSource = tags.map(t => ({
      ...t,
      color: colors[t.value],
      hidden: hiddenSeries[t.value],
    }));
    const { selectedTag } = this.state;
    const metaColumns = [
      {
        key: 'meta',
        dataIndex: 'label',
        title: 'Meta',
      },
      {
        key: 'value',
        dataIndex: 'value',
        title: 'Value',
      },
    ];
    let metaSource = [];
    if (selectedTag) {
      const tag = tags.find(t => t.value === selectedTag);
      metaSource = [
        {
          label: 'Unit',
          value: tag.engunit,
        },
        {
          label: 'Zero value',
          value: tag.zero,
        },
        {
          label: 'Span value',
          value: tag.span,
        },
        {
          label: 'Typical value',
          value: tag.typicalValue,
        },
      ];
    }
    const hidden = hiddenSeries[selectedTag];
    return (
      <div style={{ padding: '15px' }}>
        <SidebarWrapper>
          <ListWrapper>
            <h1 style={{ color: 'white' }}>EDIT TAGS</h1>
            {dataSource.map(d => (
              <TagListItem
                {...d}
                key={d.value}
                hidden={d.hidden}
                selected={selectedTag === d.value}
                onClick={() => {
                  this.setState({
                    selectedTag: selectedTag === d.value ? null : d.value,
                  });
                }}
              />
            ))}
          </ListWrapper>
          {selectedTag && (
            <SettingsWrapper>
              <h2 style={{ color: 'white' }}>SELECT COLOR</h2>
              <SketchPicker
                onChangeComplete={c => handleColorChange(c, selectedTag)}
                color={colors[selectedTag]}
                presetColors={chartColors}
                disableAlpha
              />
              {onChangeAxisConfig && (
                <AxisRangeSelector
                  onChange={this.onChangeAxisConfig}
                  axisConfig={this.props.axisConfig[selectedTag]}
                />
              )}
              {onChangeStrokeWidth && (
                <StrokeWidthSelector
                  onChange={this.onChangeStrokeWidth}
                  strokeWidth={this.props.strokeWidths[selectedTag]}
                />
              )}
              <Table
                pagination={false}
                dataSource={metaSource}
                columns={metaColumns}
                style={{ background: 'white', marginTop: '10px' }}
                rowKey="label"
              />
              <Button
                style={{ marginTop: '10px' }}
                onClick={() => {
                  this.props.toggleHide(selectedTag);
                }}
              >
                {hidden ? 'Show' : 'Hide'}
              </Button>
              <Button
                style={{ marginTop: '10px', marginLeft: '10px' }}
                onClick={() => {
                  const newTags = this.props.tags.filter(
                    t => t.value !== selectedTag
                  );
                  const updates = { selectedTag: null };
                  if (newTags.length > 0) {
                    updates.selectedTag = newTags[0].value;
                  }
                  this.setState(updates);
                  removeTag(selectedTag);
                }}
              >
                Remove tag
              </Button>
            </SettingsWrapper>
          )}
        </SidebarWrapper>
      </div>
    );
  }
}

export default EditTagSidebar;



// WEBPACK FOOTER //
// ./src/components/ChartView/EditTagSidebar.js